export enum IconType {
  'arrow-down' = 'arrow-down',
  'arrow-left' = 'arrow-left',
  'arrow-right' = 'arrow-right',
  'arrow-up' = 'arrow-up',
  'briefcase' = 'briefcase',
  'briefcase-outline' = 'briefcase-outline',
  'calculate-route' = 'calculate-route',
  'calendar' = 'calendar',
  'calendar-outline' = 'calendar-outline',
  'car' = 'car',
  'car-outline' = 'car-outline',
  'cards' = 'cards',
  'cards-outline' = 'cards-outline',
  'categories' = 'categories',
  'categories-outline' = 'categories-outline',
  'check' = 'check',
  'check-circle' = 'check-circle',
  'check-circle-outline' = 'check-circle-outline',
  'chevron-down' = 'chevron-down',
  'chevron-left' = 'chevron-left',
  'chevron-right' = 'chevron-right',
  'chevron-up' = 'chevron-up',
  'clipboard' = 'clipboard',
  'clipboard-outline' = 'clipboard-outline',
  'clock' = 'clock',
  'clock-outline' = 'clock-outline',
  'close' = 'close',
  'close-circle' = 'close-circle',
  'close-circle-outline' = 'close-circle-outline',
  'coins' = 'coins',
  'coins-outline' = 'coins-outline',
  'deactivated' = 'deactivated',
  'deactivated-outline' = 'deactivated-outline',
  'dollar-sign' = 'dollar-sign',
  'double-arrow-left' = 'double-arrow-left',
  'double-arrow-right' = 'double-arrow-right',
  'download' = 'download',
  'download-outline' = 'download-outline',
  'download-excel' = 'download-excel',
  'download-excel-outline' = 'download-excel-outline',
  'download-pdf' = 'download-pdf',
  'download-pdf-outline' = 'download-pdf-outline',
  'edit' = 'edit',
  'edit-outline' = 'edit-outline',
  'edit-circle' = 'edit-circle',
  'edit-circle-outline' = 'edit-circle-outline',
  'exclamation-mark' = 'exclamation-mark',
  'expand' = 'expand',
  'expense' = 'expense',
  'expense-outline' = 'expense-outline',
  'eye-closed' = 'eye-closed',
  'eye-closed-outline' = 'eye-closed-outline',
  'eye-open' = 'eye-open',
  'eye-open-outline' = 'eye-open-outline',
  'favorite-place' = 'favorite-place',
  'favorite-place-outline' = 'favorite-place-outline',
  'filter' = 'filter',
  'filter-outline' = 'filter-outline',
  'flag' = 'flag',
  'flag-outline' = 'flag-outline',
  'gear' = 'gear',
  'gear-outline' = 'gear-outline',
  'gps-outline' = 'gps-outline',
  'grip' = 'grip',
  'grip-outline' = 'grip-outline',
  'heart' = 'heart',
  'heart-outline' = 'heart-outline',
  'help' = 'help',
  'help-outline' = 'help-outline',
  'home' = 'home',
  'home-outline' = 'home-outline',
  'info' = 'info',
  'info-outline' = 'info-outline',
  'integrations' = 'integrations',
  'integrations-outline' = 'integrations-outline',
  'key' = 'key',
  'key-outline' = 'key-outline',
  'light-bulb' = 'light-bulb',
  'light-bulb-outline' = 'light-bulb-outline',
  'link' = 'link',
  'loading' = 'loading',
  'lock' = 'lock',
  'lock-outline' = 'lock-outline',
  'logout-outline' = 'logout-outline',
  'map' = 'map',
  'map-outline' = 'map-outline',
  'marker' = 'marker',
  'marker-outline' = 'marker-outline',
  'minus' = 'minus',
  'more-horizontal' = 'more-horizontal',
  'more-vertical' = 'more-vertical',
  'note' = 'note',
  'note-outline' = 'note-outline',
  'open' = 'open',
  'person' = 'person',
  'person-check' = 'person-check',
  'person-check-outline' = 'person-check-outline',
  'person-circle' = 'person-circle',
  'person-circle-outline' = 'person-circle-outline',
  'person-outline' = 'person-outline',
  'photo' = 'photo',
  'photo-outline' = 'photo-outline',
  'pin-and-pen' = 'pin-and-pen',
  'pin-and-pen-outline' = 'pin-and-pen-outline',
  'play' = 'play',
  'plus' = 'plus',
  'premium' = 'premium',
  'question' = 'question',
  'reimbursement' = 'reimbursement',
  'reimbursement-outline' = 'reimbursement-outline',
  'report' = 'report',
  'report-outline' = 'report-outline',
  'round-trip' = 'round-trip',
  'rules' = 'rules',
  'rules-outline' = 'rules-outline',
  'schedule' = 'schedule',
  'schedule-outline' = 'schedule-outline',
  'search' = 'search',
  'search-empty' = 'search-empty',
  'share' = 'share',
  'sheets-outline' = 'sheets-outline',
  'shop' = 'shop',
  'shop-outline' = 'shop-outline',
  'sort' = 'sort',
  'star' = 'star',
  'star-outline' = 'star-outline',
  'steering-wheel' = 'steering-wheel',
  'summary' = 'summary',
  'summary-outline' = 'summary-outline',
  'synced' = 'synced',
  'tag' = 'tag',
  'tag-outline' = 'tag-outline',
  'tax' = 'tax',
  'tax-outline' = 'tax-outline',
  'team' = 'team',
  'team-outline' = 'team-outline',
  'tracker' = 'tracker',
  'tracker-outline' = 'tracker-outline',
  'transaction' = 'transaction',
  'transaction-outline' = 'transaction-outline',
  'trash' = 'trash',
  'trash-outline ' = 'trash-outline',
  'trip' = 'trip',
  'trip-outline' = 'trip-outline',
  'upload' = 'upload',
  'upload-csv' = 'upload-csv',
  'upload-csv-outline' = 'upload-csv-outline',
  'upload-outline' = 'upload-outline',
  'vehicle' = 'vehicle',
  'vehicle-outline' = 'vehicle-outline',
  'wallet' = 'wallet',
  'wallet-outline' = 'wallet-outline',
  'wallet-with-bill' = 'wallet-with-bill',
  'wallet-with-bill-outline' = 'wallet-with-bill-outline',
  'work' = 'work',
  'work-outline' = 'work-outline'
}

export enum FeatureIconType {
  'beach-chair' = 'beach-chair',
  'car-in-motion' = 'car-in-motion',
  'everlance' = 'everlance',
  'everlance-logo' = 'everlance-logo',
  'everlance-by-motus-logo' = 'everlance-by-motus-logo',
  'expenses' = 'expenses',
  'money-in-wallet' = 'money-in-wallet',
  'pay-report' = 'pay-report',
  'tags' = 'tags',
  'work-hours' = 'work-hours',
  'data-exports' = 'data-exports',
  'wallet-send-payments' = 'wallet-send-payments',
  'rules' = 'rules',
  'flags' = 'flags',
  'wallet' = 'wallet',
  'calendar' = 'calendar',
  'flags-banner' = 'flags-banner',
  'insurance' = 'insurance',
  'categories' = 'categories',
  'driver-checkup' = 'driver-checkup',
  'sedan-driving' = 'sedan-driving',
  'product' = 'product',
  'time' = 'time',
  'trips' = 'trips',
  'transactions' = 'transactions',
  'share' = 'share',
  'reports' = 'reports',
  'premium' = 'premium',
  'location' = 'location',
  'data-export' = 'data-export',
  'credit-cards' = 'credit-cards',
  'expense-sync' = 'expense-sync',
  'confetti' = 'confetti',
  'clapping' = 'clapping',
  'visibility' = 'visibility',
  'motus-logo' = 'motus-logo'
}

export enum ImgIconType {
  'Wagon' = 'Pioneer+Wagon+Filled-100.png',
  'Rocket' = 'Launched+Rocket+Filled-100.png',
  'PropPlane' = 'Prop+Plane+Filled-100.png',
  'GoKart' = 'Go+Kart+Filled-100.png',
  'RaceCar' = 'F1+Race+Car+Side+View+Filled-100.png',
  'Convertible' = 'Convertible+Filled-100.png',
  'Pickup' = 'Pickup+filled+100-1.png',
  'Truck' = 'Truck+filled+100.png',
  'Sedan' = 'Sedan+Filled-100-2.png'
}
